/* eslint-disable no-unused-vars */
import ptBR from 'I18n/Translate/locales/ptBR';
import es from 'I18n/Translate/locales/es';

import {
	getReplacedStringVariables,
	getTranslateStringByStringKey,
} from 'I18n/Translate';
import { formatDateByRegion } from 'I18n/Timezone';
import { localeOptions, timeZoneOptions } from './types';

interface RegionChangerProps {
	defaultLocale: localeOptions;
	locale: localeOptions;
	defaultTimeZone: timeZoneOptions;
	timeZone: timeZoneOptions;
}

const RegionChanger = ({
	defaultLocale,
	locale,
	defaultTimeZone,
	timeZone,
}: RegionChangerProps) => {
	const getTranslate = () => {
		const translates = {
			'pt-br': ptBR,
			pt: ptBR,
			es: es,
		};

		const language = locale || defaultLocale;

		return translates[language];
	};

	const translate = (stringKey: string, variables: any) => {
		if (stringKey?.includes('.')) {
			const translates = getTranslate();
			const stringTranslate = getTranslateStringByStringKey(
				stringKey,
				translates,
			);
			const stringTranslateWithVariables = getReplacedStringVariables(
				variables,
				stringTranslate,
			);

			return stringTranslateWithVariables;
		} else {
			return stringKey;
		}
	};

	const formatTimezone = (date: Date, formatStr: string) => {
		const formattedTimeZone = timeZone || defaultTimeZone;

		return formatDateByRegion(date, formattedTimeZone, formatStr);
	};

	return {
		getTranslate,
		translate,
		formatTimezone,
	};
};

export default RegionChanger;
